exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".large-text[data-v-729f24a8] {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.large-text h1[data-v-729f24a8] {\n  line-height: 1;\n}", ""]);

// exports
